import App from './views/App.vue';
import Breadcrumb from './components/breadcrumb';
import LoadingState from './components/LoadingState.vue';
import GullKit from './plugins/gull.kit';
import router from './router';
import store from './store';
import Vue from 'vue';

import {
  formatDate,
  getCurrentYear,
  formatBytes,
  showSuccessNotification,
  showErrorNotification,
  titleCase,
  truncateString,
  countCharacters,
  countSegments,
  formatCurrency,
  formatTIN,
  formatPhoneNumber,
  formatBRN
} from './helper';

import {
  validateTIN,
  validateBRN,
  validateMSIC,
  validateAmount,
  validatePhoneNumber,
  validateEmail,
  validateInvoiceId
} from './utils/validators';

require('./bootstrap');

Vue.prototype.formatDate = formatDate;
Vue.prototype.getCurrentYear = getCurrentYear;
Vue.prototype.formatBytes = formatBytes;
Vue.prototype.showSuccessNotification = showSuccessNotification;
Vue.prototype.showErrorNotification = showErrorNotification;
Vue.prototype.titleCase = titleCase;
Vue.prototype.truncateString = truncateString;
Vue.prototype.countCharacters = countCharacters;
Vue.prototype.countSegments = countSegments;
Vue.prototype.formatCurrency = formatCurrency;
Vue.prototype.formatTIN = formatTIN;
Vue.prototype.formatPhoneNumber = formatPhoneNumber;
Vue.prototype.formatBRN = formatBRN;

Vue.prototype.validateTIN = validateTIN;
Vue.prototype.validateBRN = validateBRN;
Vue.prototype.validateMSIC = validateMSIC;
Vue.prototype.validateAmount = validateAmount;
Vue.prototype.validatePhoneNumber = validatePhoneNumber;
Vue.prototype.validateEmail = validateEmail;
Vue.prototype.validateInvoiceId = validateInvoiceId;

Vue.use(GullKit);

Vue.component('breadcrumb', Breadcrumb);
Vue.component('LoadingState', LoadingState);

Vue.config.productionTip = false;

const app = new Vue({
  el: '#app',
  components: {
    App,
  },
  router,
  store,
});
